// デバイス検出ユーティリティ
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // モバイルデバイスとタブレットのユーザーエージェントパターン（拡張版）
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

  return mobileRegex.test(userAgent);
};

export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // タブレットデバイスの包括的なユーザーエージェントパターン
  const tabletRegex =
    /iPad|Android.*Tablet|Kindle|Silk.*Accelerated|Tablet|PlayBook|Nexus 7|Nexus 10|Xoom|Transformer|Tab|Galaxy Tab|Surface|Windows.*Tablet|iPadOS/i;

  // タッチサポートと画面サイズもチェック
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  // タブレット判定：ユーザーエージェントパターン OR (タッチ対応かつ中程度の画面サイズ)
  const isTabletByUserAgent = tabletRegex.test(userAgent);
  const isTabletByScreenSize =
    hasTouch &&
    ((screenWidth >= 600 && screenWidth <= 1200) ||
      (screenHeight >= 600 && screenHeight <= 1200));

  return isTabletByUserAgent || isTabletByScreenSize;
};

export const isDesktopDevice = () => {
  return !isMobileDevice() && !isTabletDevice();
};

// すべてのモバイルデバイス（スマホ + タブレット）を検出
export const isAnyMobileDevice = () => {
  return isMobileDevice() || isTabletDevice();
};
